import React from "react";
import { Routes, Route } from "react-router-dom";
import GMapActif from "../component/GMap/GMapActif";
import { Notification } from "../component/Notification/notifications";
import { Faq } from "../component/Faq/Faq"; 
import { CGU } from "../component/CGU/CGU";
import Profile from "../component/NavBar/Overlays/Profile";
import {ListActif} from "../component/Tab/ListActif/ListActif"
import {MentionLegales} from "../component/MentionLegales/MentionLegales"
import News from "./News/News";
import { classNames } from "primereact/utils";
import DashboardTab from "../component/Dashboard/DashboardTab";
import Utilisateurs from "../component/NavBar/Overlays/Utilisateurs";
import MotDePasseOublie from "./MotDePasseOublie"
import TabLivrable from "../component/Tab/tab";
import { CGUDisconnected } from "../component/CGUDisconnected/CGU";

export const NavPage = ({ setSearch , search , visible}) => {
  const decaler=()=> {
    if (visible) 
    return { "decal" : true}
   }
    return (
        <div className='nav-page'>
        <div className={classNames({"decal" :decaler()})}>
        <Routes>
        <Route path="/Faq" element={<Faq />} />
        <Route path="/carte" element={<GMapActif/>} />
        <Route path="/CGU" element={<CGU />} />
        <Route path="/CGUDisconnected" component={<CGUDisconnected/>} /> 
        <Route path="/News" element={<News />} />
        <Route path="/MotDePasseOublie" element={<MotDePasseOublie />} />
        <Route path="/MentionLegales" element={<MentionLegales />} />
        <Route path="/notifications" element={<Notification />} />
        <Route exact path="/gestion" element={<DashboardTab/>}  />
        <Route exact path="/utilisateurs" element={<Utilisateurs  />}  />
        <Route path="/profil" element={<Profile />} />
                              
        <Route path="/Liste" element={<ListActif search={search} setSearch={setSearch}
         
          />} />
         <Route path="/detail" element={<TabLivrable />} />
   
        </Routes>
        </div>
      </div>
    )
}